import { Components, Formio } from 'formiojs';
import FieldComponent from 'formiojs/components/_classes/field/Field';

export class GeoLocationComponent extends FieldComponent {
  refs: any;
    loadRefs: any;
    addEventListener: any;
    setValue: any;
  static schema(...extend: any[]) {
    return FieldComponent.schema(
      {
        type: 'geolocation',
        label: 'Geo Location',
        key: 'geolocation',
        input: true,
      },
      ...extend
    );
  }

  static builderInfo = {
    title: 'Geo Location',
    group: 'basic',
    icon: 'map-marker',
    weight: 70,
    schema: GeoLocationComponent.schema(),
  };

  render(children: any) {
    return super.render(`
      <div class="geolocation-container">
        <button ref="detectBtn" class="btn btn-primary" type="button">
          Detect My Location
        </button>
        <div ref="locationOutput" class="location-output mt-2">
          No location detected
        </div>
      </div>
    `);
  }

  attach(element: any) {
    // very important - this maps all refs to `this.refs`
    const refs = super.attach(element);
    this.loadRefs(element, {
      detectBtn: 'single',
      locationOutput: 'single'
    });

    if (this.refs.detectBtn) {
      this.addEventListener(this.refs.detectBtn, 'click', () => {
        this.detectLocation();
      });
    }

    return refs;
  }

  detectLocation() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          const location = `Lat: ${latitude}, Lng: ${longitude}`;
          this.setValue({ latitude, longitude });

          if (this.refs.locationOutput) {
            this.refs.locationOutput.innerHTML = location;
          }
        },
        (error) => {
          if (this.refs.locationOutput) {
            this.refs.locationOutput.innerHTML = 
              'Error detecting location: ' + error.message;
          }
        }
      );
    } else {
      if (this.refs.locationOutput) {
        this.refs.locationOutput.innerHTML =
          'Geolocation is not supported by this browser.';
      }
    }
  }
}

Formio.use({
  components: {
    geolocation: GeoLocationComponent,
  },
});
